import { FC } from "react";

import { Flex } from "@/v1/components/atoms/Flex/Flex";
import { FolderIcon } from "@/v1/components/atoms/Icons";

interface TreeItemProps {
  label: string;
  depth: number;
  displayDepth?: boolean;
}

export const TreeItem: FC<TreeItemProps> = ({ label, depth, displayDepth }) => {
  return (
    <div style={displayDepth ? { paddingLeft: `${depth * 16}px` } : {}}>
      <Flex container alignItems="center" gap={2}>
        <FolderIcon />
        {label}
      </Flex>
    </div>
  );
};
